import Vue from 'vue'
import { URL_AUTHORIZATION_DOCUMENTS } from '@/constants/urls.js'
import { AUTHORIZATION_DOCUMENT_TYPES } from '@/constants/business.js'
import { AUTHORIZATION_DOCUMENTS_MANAGEMENT, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [AUTHORIZATION_DOCUMENTS_MANAGEMENT.STATE.AUTHORIZATION_DOCUMENTS]: {
    [AUTHORIZATION_DOCUMENT_TYPES.USER_AUTHORIZATION_DOCUMENT]: null
  },
  [AUTHORIZATION_DOCUMENTS_MANAGEMENT.STATE.CURRENT_AUTHORIZATION_DOCUMENT]: null
}

const actions = {
  async [AUTHORIZATION_DOCUMENTS_MANAGEMENT.ACTIONS.GET_AUTHORIZATION_DOCUMENTS_LIST_ADMIN] ({ dispatch, commit }, model) {
    const documentType = model.documentType
    model = {
      url: `${Vue.getIdentityHost()}${URL_AUTHORIZATION_DOCUMENTS}/${model.documentType}?${Vue.helpers.getQueryParamsString(model.params)}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(AUTHORIZATION_DOCUMENTS_MANAGEMENT.MUTATIONS.GET_AUTHORIZATION_DOCUMENTS_LIST_ADMIN, {
      documentType,
      authorizationDocuments: resp.data
    })
  },
  async [AUTHORIZATION_DOCUMENTS_MANAGEMENT.ACTIONS.GET_AUTHORIZATION_DOCUMENT_ADMIN] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_AUTHORIZATION_DOCUMENTS}/${model.documentType}/${model.documentId}?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(AUTHORIZATION_DOCUMENTS_MANAGEMENT.MUTATIONS.GET_AUTHORIZATION_DOCUMENT_ADMIN, resp.data)
  },
  async [AUTHORIZATION_DOCUMENTS_MANAGEMENT.ACTIONS.CHANGE_AUTHORIZATION_DOCUMENT_STATUS] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_AUTHORIZATION_DOCUMENTS}/${model.documentType}/${model.documentId}/status`,
      model: { status: model.status }
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [AUTHORIZATION_DOCUMENTS_MANAGEMENT.ACTIONS.UPDATE_AUTHORIZATION_DOCUMENT] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_AUTHORIZATION_DOCUMENTS}/${model.documentType}/${model.documentId}`,
      model: model.authorizationDocument
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [AUTHORIZATION_DOCUMENTS_MANAGEMENT.ACTIONS.CLEAR_AUTHORIZATION_DOCUMENTS_LIST_ADMIN] ({ commit }, documentType) {
    commit(AUTHORIZATION_DOCUMENTS_MANAGEMENT.MUTATIONS.CLEAR_AUTHORIZATION_DOCUMENTS_LIST_ADMIN, documentType)
  },
  async [AUTHORIZATION_DOCUMENTS_MANAGEMENT.ACTIONS.CLEAR_AUTHORIZATION_DOCUMENT_ADMIN] ({ commit }) {
    commit(AUTHORIZATION_DOCUMENTS_MANAGEMENT.MUTATIONS.CLEAR_AUTHORIZATION_DOCUMENT_ADMIN)
  }
}

const mutations = {
  [AUTHORIZATION_DOCUMENTS_MANAGEMENT.MUTATIONS.GET_AUTHORIZATION_DOCUMENTS_LIST_ADMIN] (state, model) {
    state[AUTHORIZATION_DOCUMENTS_MANAGEMENT.STATE.AUTHORIZATION_DOCUMENTS][model.documentType] = model.authorizationDocuments
  },
  [AUTHORIZATION_DOCUMENTS_MANAGEMENT.MUTATIONS.GET_AUTHORIZATION_DOCUMENT_ADMIN] (state, authorizationDocument) {
    state[AUTHORIZATION_DOCUMENTS_MANAGEMENT.STATE.CURRENT_AUTHORIZATION_DOCUMENT] = authorizationDocument
  },
  [AUTHORIZATION_DOCUMENTS_MANAGEMENT.MUTATIONS.CLEAR_AUTHORIZATION_DOCUMENTS_LIST_ADMIN] (state, documentType) {
    state[AUTHORIZATION_DOCUMENTS_MANAGEMENT.STATE.AUTHORIZATION_DOCUMENTS][documentType] = null
  },
  [AUTHORIZATION_DOCUMENTS_MANAGEMENT.MUTATIONS.CLEAR_AUTHORIZATION_DOCUMENT_ADMIN] (state) {
    state[AUTHORIZATION_DOCUMENTS_MANAGEMENT.STATE.CURRENT_AUTHORIZATION_DOCUMENT] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
